<template>
  <v-container>
    <v-card outlined>
      <v-card-title>
        <v-flex>
          <v-layout>
            <v-flex xs4>
              <!-- <div class="subtitle-2 mb-1">Select Region</div> -->
              <!-- <v-select
                outlined
                dense
                hide-details
                return-object
                :items="regions"
                v-model="selectedRegion"
                item-text="name"
                placeholder="Select Region"
                @change="selectRegion"
              >
              </v-select> -->
            </v-flex>

            <v-flex text-right>
              <v-btn @click="refresh" depressed color="primary">
                Refresh
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3" justify-space-between>
            <v-flex xs4>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-flex>
            <v-flex xs3 text-right v-if="selectedRegion.name !== 'All'">
              <v-select
                hide-details
                outlined
                placeholder="Filter By from"
                dense
                v-model="selectedFrom"
                @change="fromSelected"
                :items="['all', 'ig-crawler', 'text', 'call']"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="dataStreamItems"
        :items-per-page="30"
        class="elevation-0"
        :search="search"
        no-data-text="No data available"
      >
        <template v-slot:item.actions="{ item }">
          <div style="min-width: 50px">
            <v-icon small class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon small class="mr-2" @click="deleteItem(item)">
              mdi-delete
            </v-icon>
          </div>

          <!-- <v-icon small @click="copyItem(item)"> mdi-content-copy </v-icon> -->
        </template>
        <template v-slot:item.content.attachment="{ item }">
          <div style="min-width: 50px">
            <v-icon
              small
              v-if="
                item.content.attachment ? item.content.attachment !== '' : false
              "
            >
              mdi-paperclip
            </v-icon>
          </div>
        </template>
        <template v-slot:item.entity.title="{ item }">
          <div style="min-width: 100px">
            {{ item.entity.title }}
          </div>
        </template>
        <template v-slot:item.state="{ item }">
          <div style="min-width: 80px">
            {{ item.state }}
          </div>
        </template>
        <!-- <template v-slot:item.scheduledAt="{ item }">
          {{ iMoment(item.scheduledAt) }}
        </template> -->
        <!-- <template v-slot:item.region="{ item }">
          <div>
            {{ item.region.name }}
          </div>
        </template> -->
        <template v-slot:item.createdAt="{ item }">
          <div style="min-width: 100px">
            {{ iMoment(item.createdAt) }}
          </div>
        </template>
      </v-data-table>
    </v-card>
    <edit-data-stream-dialog
      :selectedRegion="selectedRegion"
      :pinDetail="editedItem"
      :collection="collection"
      ref="editDataStreamDialog"
    />
    <v-dialog v-model="dialogDelete" width="300">
      <v-card>
        <v-card-title>Are you sure you want to delete this item?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="error"
            class="text-none subtitle-2"
            @click="dialogDelete = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-none subtitle-2"
            text
            @click="deleteItemConfirm"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import EditDataStreamDialog from '../components/EditDataStreamDialog.vue';
import { mapActions, mapState } from 'vuex';
import moment from 'moment';
export default {
  components: { EditDataStreamDialog },
  data() {
    return {
      selectedRegion: {},
      collection: 'pipeline',

      selectedFrom: '',

      search: '',
      dialogDelete: false,
      itemToDelete: {
        scheduledAt: '',
        state: '',

        data: {
          expiresAt: '',
          content: '',
          graphics: {
            entity: '',
            icon: {
              bgColor: '',
              color: '',
              name: '',
              type: '',
            },
          },
          image: {
            thumbnail: '',
            url: '',
          },
          isMarker: '',
          location: '',
          score: '',

          totalComments: '',
          type: '',
          views: '',
        },
      },
      headers: [
        {
          text: 'Content',
          align: 'start',
          sortable: true,
          value: 'content.text',
        },
        { text: 'Attch', value: 'content.attachment' },
        // { text: "Font Name", value: "fontName" },

        { text: 'Entity', value: 'entity.title' },
        { text: 'From', value: 'from' },
        { text: 'State', value: 'state' },
        { text: 'Created At', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      editedItem: {
        scheduledAt: '',
        state: '',
        data: {
          content: '',
          graphics: {
            entity: '',
            icon: {
              bgColor: '',
              color: '',
              name: '',
              type: '',
            },
          },
          image: {
            thumbnail: '',
            url: '',
          },
          isMarker: '',
          location: '',
          score: '',

          totalComments: '',
          type: '',
          views: '',
        },
      },
      editedIndex: -1,
      defaultItem: {
        scheduledAt: '',
        state: '',
        data: {
          content: '',
          graphics: {
            entity: '',
            icon: {
              bgColor: '',
              color: '',
              name: '',
              type: '',
            },
          },
          image: {
            thumbnail: '',
            url: '',
          },
          isMarker: '',
          location: '',
          score: '',

          totalComments: '',
          type: '',
          views: '',
        },
      },
    };
  },
  computed: {
    ...mapState('$_content', ['dataStreamItems']),
    ...mapState('$_home', ['regions']),
  },
  created() {
    this.selectedFrom = 'all';
    this.getDataStream();
    if (this.regions.length === 0) {
      this.getRegions({ collection: 'regions', mutation: 'updateRegions' });
    }
  },
  methods: {
    ...mapActions({
      getDataStream: '$_content/getDataStream',
      getDataStreamByFrom: '$_content/getStreamByFrom',
      getDataStreamByRegion: '$_content/getContentByRegion',
      deleteDataStreamItem: '$_content/deleteDataStreamItem',
      getRegions: '$_home/getContent',
    }),
    refresh() {
      this.selectedFrom = 'all';
      this.getDataStream();
    },
    // selectRegion() {
    //   // console.log("selectedRegion: ", this.selectedRegion);

    // },
    fromSelected(from) {
      console.log(from);
      if (from === 'all') {
        this.getDataStream();
      } else {
        this.getDataStreamByFrom({
          collection: 'datastream',
          mutation: 'updateDataStream',
          from: from,
        });
      }
    },

    iMoment(timestamp) {
      if (timestamp) {
        let temp = timestamp.seconds * 1000;
        return moment(temp).format('lll');
      } else {
        return 0;
      }
    },
    // openNewDataStreamDialog() {
    //   this.$refs.newDataStreamDialog.toggleDialog();
    // },
    editItem(item) {
      this.editedIndex = this.dataStreamItems.indexOf(item);
      this.editedItem = {};
      this.editedItem = Object.assign(
        {},
        this.dataStreamItems[this.editedIndex],
      );

      // console.log("Edited Item: ", this.editedItem);

      this.$refs.editDataStreamDialog.toggleDialog(this.editedItem);
    },
    searchArr(latitude, longitude, myArray) {
      for (var i = 0; i < myArray.length; i++) {
        if (
          myArray[i].latitude === latitude &&
          myArray[i].longitude === longitude
        ) {
          return myArray[i].name;
        }
      }
    },
    copyItem(item) {
      this.editedIndex = this.dataStreamItems.indexOf(item);
      this.editedItem = {};
      this.editedItem = Object.assign(
        {},
        this.dataStreamItems[this.editedIndex],
      );

      // console.log("Edited Item: ", this.editedItem);

      this.$refs.editDataStreamDialog.toggleDialog(this.editedItem, 'copy');
    },
    deleteItem(item) {
      this.editedIndex = this.dataStreamItems.indexOf(item);
      this.itemToDelete = Object.assign(
        {},
        this.dataStreamItems[this.editedIndex],
      );
      this.itemToDelete.state = 'deleted';
      this.dialogDelete = true;

      // console.log(item);
    },
    deleteItemConfirm() {
      // console.log("Deleting Item: ", this.itemToDelete);

      this.deleteDataStreamItem({
        details: this.itemToDelete,
      }).then(() => {
        this.dialogDelete = false;
        this.getDataStream();
      });
    },
  },
};
</script>

<style></style>
